import { AuthSession } from 'types';

export const getUserId = (authSession: AuthSession): string => authSession.idToken.payload['custom:salesforce_id'];
